<template>
  <div class="crudblock">
    <avue-crud
      :option="option"
      :data="data"
      ref="crud"
      :page.sync="page"
      :search.sync="query"
      v-model="form"
      :before-open="beforeOpenScope"
      @on-load="onLoad"
      @search-change="searchChange"
      @search-reset="searchReset"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @sort-change="sortChange"
    >
      <template slot="search"></template>
      <template slot-scope="scope" slot="menu" menuAlign="left">
        <el-button
          type="success"
          plain
          size="small"
          icon="el-icon-arrow-right"
          @click.stop="handleDetail(scope.row)"
          >详情
        </el-button>
      </template>
       <template slot="menuRight" slot-scope="scope"> 
       <el-tooltip class="item" effect="dark" content="显隐"
             placement="top">
            <el-button icon="el-icon-s-operation"
              circle @click="operation" ></el-button>
          </el-tooltip>
          </template>
      <template slot="searchMenu" slot-scope="{ row }">
        <el-button type="primary" @click="save(row)">保存</el-button>
        <el-button type="primary"  @click="screen"
          ><a-icon type="filter" /> 高级筛选</el-button
        >
      </template>
    </avue-crud>
    <el-drawer
      title="高级筛选"
      :visible.sync="drawer"
      size="50%"
      custom-class="drawer_wrapper"
      :with-header="false"
    >
      <span>
        <div class="drawer_screen_wrapper">
          <div class="screen_header">
            <div class="screen_header_name">
              <a-icon type="filter" />
              高级筛选
            </div>
            <div class="screen_header_remarks" @click="drawer = false">
              <i class="el-icon-video-play"></i>
              收起
            </div>
          </div>
          <div class="screen_content">
            <avue-form
              :option="option"
              ref="formScreen"
              v-model="formScreen"
              @submit="handleSearch"
              @reset-change="searchResetScreen"
            >
              <template slot="search"></template>
              <template slot="expireQuotaSlot">
                <div class="form_slot">
                  <el-input-number
                    v-model="formScreen.expireQuotaMin"
                    :controls="false"
                    placeholder="开始数值"
                    style="width: 100%"
                  />
                  ~
                  <el-input-number
                    v-model="formScreen.expireQuotaMax"
                    :controls="false"
                    placeholder="结束数值"
                    style="width: 100%"
                  />
                </div>
              </template>
              <template slot="quotaSlot">
                <div class="form_slot">
                  <el-input-number
                    v-model="formScreen.quotaMin"
                    :controls="false"
                    placeholder="开始数值"
                    style="width: 100%"
                  />
                  ~
                  <el-input-number
                    v-model="formScreen.quotaMax"
                    :controls="false"
                    placeholder="结束数值"
                    style="width: 100%"
                  />
                </div>
              </template>
            </avue-form>
          </div>
        </div>
      </span>
    </el-drawer>
   <Options ref="Options"
          :plainOptions="optionColumn"
          :pageDataId="this.$route.path"
          @returnData="returnData"
        /> 
  </div>
</template>

<script>
import * as api from "@/api/zd/project";
import SelectPerson from "@/components/SelectPersonnel/person";
import TagsCloud from "@/components/TagsCloud/TagsCloud";
import Options from "@/components/ShowHidden/showhidden";
export default {
  name: "projectManage",
  data() {
    return {
      optionColumn: [],
      drawer: false,
      shlb: 0,
      form: {},
      formScreen: {},
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      query: {},
      data: [],

      option: {
        // excelBtn: true,
        menuType: "button",
        menuWidth: 120, 
 menuAlign: "center",
        align: "center",
        card: true,
        columnBtn: false,
        searchBtn: true,
        refreshBtn:false,
        tip: false,
        lazy: true,
        simplePage: true,
        searchShow: true,
        searchMenuSpan: 6,
        tree: true,
        editBtn: false,
        addBtn: false,
        delBtn: false,
        labelWidth: 120,
        column: [
          {
            label: "搜索查询",
            searchPlaceholder: "项目编号/项目名称/客户名称",
            placeholder: "项目编号/项目名称/客户名称",
            prop: "search",
            hide: true,
            display: true,
            search: true,
            hideshow:true
          },
        

          {
            label: "贷款到期金额",
            prop: "expireQuotaSlot",
            formslot: true,
            hide: true, 
            display: true,
            hideshow:true
          },
          {
            label: "申请转贷金额",
            prop: "quotaSlot",
            formslot: true,
            hide: true,
            display: true,
            hideshow:true
          },
          {
            sortable: "custom",
            label: "项目编号",
            prop: "number",
            fixed: true,
            filterable: false,
            display: false,
             width:120
          },
          {
            label: "项目名称",
            prop: "name",
            fixed: true,
             width:200,
            display: false,
          },
            {
            label: "客户名称",
            prop: "custId",
            type: "select",
            filterable:'true' ,
            dicUrl: "/api/blade-/zd/custom/getListDefault",
            dicMethod: "post",
            dicQuery: {},
            props: {
              label: "custName",
              value: "id",
            },
            dataType: "string",
            display: true,
              width:200,
          },
          // {
          //   label: "客户名称",
          //   prop: "custName",
          //   display: false,
          //   hideshow:true
          // },

          {
            label: "申请银行",
            prop: "bankName",
              width:150,
            display: false,
          },
          {
            label: "申请银行",
            prop: "bankId",
            type: "select",
            filterable:'true' ,
            dicData: [],
            dataType: "string",
            search: true,
            hide: true,
            display: true,
            hideshow:true
          },
          {
            sortable: "custom",
            label: "贷款到期金额",
            prop: "expireQuota",
            width: 120,
            display: false,
          },
          {
            sortable: "custom",
            label: "申请转贷金额",
            prop: "quota",
            width: 120,
            display: false,
          },
          {
            label: "使用费率",
            prop: "loanRate",
            type: "select",
            dicUrl: "/api/blade-/zd/interestrate/dictionary",
            dicMethod: "get",
            dicQuery: {},
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "number",
            search: true,
          },
          {
            label: "客户经理",
            prop: "managerName",
            display: false,
          
          },
          {
            label: "客户经理",
            prop: "managerUserName",
            readonly: true,

            search: true,
            clearable: false,
            display: true,
            hide: true,
            hideshow: true,
            click: () => {
              this.selectPersonClick();
            },
          },
          {
            label: "审批状态",
            prop: "wfStatus",
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=wf_status",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "number",
            display: false,
          },
          {
            label: "归档状态",
            prop: "auditState",
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=guidang_style",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "number",
            display: false,
          },
        ],
      },
    };
  },
  watch: {
    files: {
      handler(newName, oldName) {
        if (oldName != undefined) {
          this.cloudTages(newName);
        }
      },

      immediate: true,
    },
  },
  components: {
    TagsCloud,Options
  },
  mounted() {
    this.optionColumn = this.deepClone(this.option.column)
    this.getListDefault();
  },
  activated() {
    this.onLoad(this.page)
  },  
  methods: {
     //显隐
    operation() {
      this.$refs.Options.showmode();
    },
     //回调
    returnData(data) {
      this.option.column = data;
    },
    onLoad(page) {
      api
        .getListProject({
          firstNum: (page.currentPage - 1) * page.pageSize,
          num: page.pageSize,
          auditState: 1,
          ...this.query,
        })
        .then((res) => {
          this.auditlistNub = res.data.data.shlb;
          this.page.total = res.data.data.total;
          this.data = res.data.data.list;
        })
        .catch((res) => {
          
        });
    },
    //申请银行列表
    getListDefault() {
      api.getListDefault({}).then((res) => {
        const column = this.findObject(this.option.column, "bankId");
        column.dicData = res.data.data.map((item) => {
          return {
            label: item.bankName,
            value: item.id,
          };
        });
      });
    },
    //新增
    rowSave(row, done, loading) {
      api.submitCustom(row).then(
        (res) => {
          // 获取新增数据的相关字段
          const data = res.data.data;

          this.$message({
            type: "success",
            message: "操作成功!",
          });
          // 数据回调进行刷新
          done(row);
        },
        (error) => {
          
          loading();
        }
      );
    },
    //修改
    rowUpdate(row, index, done, loading) {
      let data = {
        custType: row.custType,
        custName: row.custName,
        idcard: row.custType == 1 ? row.idcard : "",
        unifiedSocialCreditCode:
          row.custType == 2 ? row.unifiedSocialCreditCode : "",
        businessManagerId: row.businessManagerId,
        businessManage: row.businessManage,
        id: row.id,
      };
      api.submitCustom(data).then(
        () => {
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          // 数据回调进行刷新
          done(row);
        },
        (error) => {
          
          loading();
        }
      );
    },

    beforeOpenScope(done, type) {
      if (["add"].includes(type)) {
        api.getUsers({ type: 1 }).then((res) => {
          this.form.custType = 1;
          this.form.businessManage = res.data.data[0].id;
        });
      }
      // if (["edit", "view"].includes(type)) {
      // }
      done();
    },

    //导出
    handleExport() {
      // this.$confirm("是否导出拜访数据?", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // }).then(() => {
      //   window.open(
      //     `/api/zd/visit/export?${
      //       this.website.tokenHeader
      //     }=${getToken()}&account=${this.search.account}&realName=${
      //       this.search.realName
      //     }`
      //   );
      // });
    },
    //排序
    sortChange(val) {
      this.query.orderValue =
        val.order == "descending"
          ? "desc"
          : val.order == "ascending"
          ? "asc"
          : "";

      this.query.orderName = val.prop;
      this.page.currentPage = 1;
      this.onLoad(this.page);
      // done();
    },
    //搜索
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page);
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    //高级筛选清空
    searchResetScreen(){
      this.$refs.crud.searchReset()
    },
    save(row) {
      this.$emit("rowdata", row);
    },
    cloudTages(data) {
      this.form = data;

      this.searchChange(data);
    },
    //显示高级筛选抽屉
    screen() {
      this.form = { ...this.form, ...this.query };
      this.drawer = true;
    },
    //高级筛选
    handleSearch(form, done, loading) {
      this.query = { ...this.query, ...form };
      this.drawer = false;
      this.page.currentPage = 1;
      this.onLoad(this.page);
      done();
    },
    //立项
    handleApproval() {
      // this.$refs.crud.rowAdd();
      this.$router.push({ path: `/zd/project/approval/-1` });
    },
    //编辑
    handleEdit(row) {
      // this.$refs.crud.rowEdit();
      this.$router.push({ path: `/zd/project/approval/${row.id}` });
    },
    //详情
    handleDetail(row) {
      this.$router.push({ path: `/zd/project/detail/${row.id}` });
    },
    //删除
    handleDel(row) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return api.deleteProject({ id: row.id });
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.$refs.crud.toggleSelection();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.projectManage {
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
  .crudblock {
    background: #ffff;
    padding:16px;
    border-radius: 4px;
  }
}
.input_width {
  width: 220px;
}

.none-border {
  border: 0;
  background-color: transparent !important;
}
</style>

